// useLoyaltyRoute.js
import { useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

export const useLoyaltyRoute = () => {
  const location = useLocation();
  const storedOrderId = useRef(null);
  const [isLoyalty, setIsLoyalty] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const orderIdFromUrl = searchParams.get('orderId');

    if (!storedOrderId.current && orderIdFromUrl) {
      storedOrderId.current = orderIdFromUrl;
    }

    setIsLoyalty(location.pathname === '/loyalty');
  }, [location]);

  return {
    isLoyalty,
    orderId: storedOrderId.current,
  };
};
